/* src/app/components/ai-assist/botleave-planner/botleave-planner.component.scss */
:host {
  width: 100%;
  margin-top: -10px;
}
p.disclaimer {
  color: #000000 !important;
  font-size: 14px;
  padding: 0px 10px 10px;
  width: 80%;
  font-family: sans-serif;
  margin: auto;
}
p.disclaimer label span {
  display: inline-block;
  background: #fff;
  padding: 10px;
  color: orange;
  box-shadow: 0px 0px 4px rgba(85, 85, 85, 0.4);
}
p.disclaimer .expan-down-arrow {
  display: flex;
  justify-content: center;
}
p.disclaimer .expan-down-arrow a {
  background-color: #fff;
  padding: 7px;
}
p.disclaimer .expan-down-arrow a .fa {
  font-size: 1.5rem !important;
}
#leave-planner {
  background: transparent;
  width: 90%;
  min-height: 100vh;
  position: relative;
  margin: 10px auto;
}
#leave-planner form {
  position: relative;
  margin-bottom: 10px;
  display: inline-block;
  width: 98%;
  background: #fff;
  padding: 1rem;
  box-shadow: 1px 0px 4px rgba(85, 85, 85, 0.4);
  border-radius: 5px;
}
#leave-planner label {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
  width: 70%;
  display: inline-block;
}
.select {
  width: 100%;
}
select {
  width: 100%;
  border-radius: 5px;
  border-color: #565c78;
  color: #000 !important;
}
.is-rounded {
  color: #000 !important;
}
#chat-list {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 260px);
  -ms-overflow-style: none;
  scrollbar-width: none;
}
#chat-list li {
  list-style: none;
}
.button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.answer-list {
  margin: 10px 0px;
}
.answer {
  background: #fff;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #666;
  margin: 0.2rem 0;
  display: flex;
  flex-direction: column;
  width: 98%;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.answer .answer-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 15px;
}
.answer .answer-header span {
  font-weight: bold;
}
.answer .audio {
  cursor: pointer;
}
.answer .menu-list {
  position: relative;
  width: 30%;
}
.answer .menu-list ul {
  position: absolute;
  top: -10px;
  right: 0px;
  width: max-content;
}
.answer .menu-list ul li {
  margin: 10px 10px;
  display: inline-block;
  cursor: pointer;
}
.answer .menu-list ul li:hover .fa {
  color: #008cb3;
}
.answer .menu-list ul.active {
  display: block;
}
.answer .menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.answer .dropdown-menu {
  left: -55px !important;
}
.answer .dropdown-item {
  padding: 0px !important;
}
.answer .dropdown-item li {
  margin: 5px 0px !important;
  font-size: 12px !important;
  width: 100%;
  padding: 5px 10px;
}
.answer .dropdown-item li:hover {
  background: var(--primarylightColor);
  color: var(--primaryColor);
}
.answer-content {
  position: relative;
  padding: 5px;
  line-height: 1.6;
  font-size: 0.9rem;
  color: #111;
}
.answer-content ol {
  padding: 30px;
}
.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}
.comment-area-box {
  display: none;
  background: #fff;
  padding: 15px 10px 5px;
  width: 80%;
}
.comment-area-box label {
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 5px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}
.comment-area-box.is-active {
  display: flex;
  margin-top: 10px;
  align-items: center;
}
.comment-form {
  margin-left: 10px;
}
.comment-form label {
  font-size: 0.9rem;
}
.comment-form textarea {
  margin-right: 25px;
}
.comment-form .comments-field {
  margin-top: 10px;
}
.comment-form .comments-field form {
  box-shadow: none !important;
}
.comment-form .comments-field .form-btns {
  float: right;
}
.comment-form .button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  .hidemobileView {
    display: none;
  }
}
@media screen and (max-width: 640px) {
  #chat-list {
    height: calc(100vh - 360px) !important;
  }
  .answer-header label {
    margin-top: 15px !important;
  }
  #leave-planner {
    width: 100%;
    left: 0%;
  }
  #leave-planner label {
    margin-bottom: 0px;
  }
  p.disclaimer {
    width: 100%;
  }
}
/*# sourceMappingURL=botleave-planner.component.css.map */
